"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = useStateFromInput;
const react_1 = require("react");
/**
 * This hook helps when state variables are bound to inputs (text, passwords, etc). It creates and returns
 * a function as the second value, which can be passed to onChange right away.
 *
 * @param initialState
 * @returns
 */
function useStateFromInput(initialState) {
    const [value, setValue] = (0, react_1.useState)(initialState);
    const handleInputCallback = (0, react_1.useCallback)((event) => {
        setValue(event.target?.value);
    }, [setValue]);
    return [value, handleInputCallback, setValue];
}
